// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Vuex from 'vuex'
import store from './store/index'
import iconfont from './assets/iconfont/iconfont.css'
import uilts from "./common/js/uilts"
import CreateAPI from 'vue-create-api'
import mytoast from "./components/public/mytoast"
import iView from 'iview';
import 'iview/dist/styles/iview.css';
Vue.use(CreateAPI)
Vue.use(CreateAPI, {
  componentPrefix: 'cube-',
  apiPrefix: '$create-'
})
Vue.createAPI(mytoast, true)

Vue.use(iView);
// import config from '@/config'
import wx from 'weixin-js-sdk';
import Vant from 'vant';
import 'vant/lib/index.css';
// axios.defaults.baseURL = 'http://mockjs.com/api' // 设置默认请求的url
// import audio from 'vue-mobile-audio'
// Vue.use(audio)
// import VueVideoPlayer from 'vue-video-player'
// import 'video.js/dist/video-js.css'
// Vue.use(VueVideoPlayer)


// import share from '@/share.js'
// Vue.use(share)

Vue.prototype.$http = axios
Vue.use(Vant);
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$store = store
Vue.use(uilts)
// Vue.prototype.$config = config
// Vue.config.productionTip = false



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  Vuex,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js